import { useNavigate } from "react-router-dom";
import { DeleteIcon, EditIcon } from "../../assets/icons/Svgs";
import { eliminarEstudiante } from "../../services/estudiante.service";
import { showAlertDescongelar, showDeletedAlert, showErrorAlert, showQuestionDeleteAlert, showUpdateAlert } from "../../components/molecules/ShowAlert";

export const EstudianteActivoCard = ({ estudiante, index }) => {
  const navigate = useNavigate();

  const { estudiante: datosEst = {}, persona = {}, usuario = {}, registro = {} } = estudiante || {};

  const tipoAdmision = datosEst?.tipoAdmision || "N/A";

  const grupoNombre = registro?.grupo?.nombre || estudiante?.grupoNombre || "N/A";

  const tipoCongelacion = (datosEst?.tipoCongelacion || "").toString().trim().toLowerCase();
  const estaCongelado = tipoCongelacion === "voluntario" || tipoCongelacion === "institucional";

  const handleUpdate = () => {
    showUpdateAlert({
      callback: () => navigate(`/estudiantes/actualizar/${datosEst?.idEstudiante}`),
    });
  };

  const handleAsignarModulo = () => {
    if (estaCongelado) {
      showAlertDescongelar({
        icon: "warning",
        text: `No puedes asignar módulo al estudiante ${persona?.nombre} ${persona?.apellido} mientras esté congelado. Debes descongelarlo.`,
      });
      return;
    }
    navigate(`/asignar-modulo/${datosEst?.idEstudiante}`, { state: { estudiante } });
  };

  const handleDelete = async () => {
    showQuestionDeleteAlert({
      callback: async (result) => {
        if (!result.isConfirmed) return;
        try {
          await eliminarEstudiante(datosEst?.idEstudiante);
          showDeletedAlert({});
        } catch (error) {
          console.error("Error al eliminar el estudiante:", error);
          showErrorAlert({});
        }
      },
    });
  };

  return (
    <tr className="bg-white hover:bg-gray-100 transition-colors duration-300 [&>td]:p-3 [&>td]:text-gray-700 [&>td]:whitespace-nowrap">
      <td className="font-medium border-r border-slate-200 border-t">{index + 1}</td>
      <td className="border-r border-slate-200 border-t">{persona?.nombre}</td>
      <td className="border-r border-slate-200 border-t">{persona?.apellido}</td>
      <td className="border-r border-slate-200 border-t">{usuario?.username}</td>
      <td className="border-r border-slate-200 border-t">{persona?.celular}</td>
      <td className="border-r border-slate-200 border-t">{tipoAdmision}</td>
      <td className="border-r border-slate-200 border-t">{grupoNombre}</td>
      <td className="border-r border-slate-200 border-t">{persona?.sexo}</td>
      <td
        className={`border-r border-slate-200 border-t ${
          tipoAdmision === "Regular" ? "bg-blue-100 text-blue-800 font-semibold" : ""
        }`}
      >
        {datosEst?.credito ?? "No asignado"}
      </td>
      <td className="border-r border-slate-200 border-t">
        <div className="flex justify-start gap-4">
          <button
            onClick={handleAsignarModulo}
            className={`font-semibold transition-colors py-1 px-4 rounded-lg shadow-md ${
              estaCongelado ? "bg-gray-400 cursor-not-allowed text-white" : "bg-theme-yellow hover:bg-yellow-500 text-white"
            }`}
          >
            Asignar módulo
          </button>

          <button onClick={handleUpdate} className="bg-green-500 p-1 rounded-md text-white">
            <EditIcon className="w-5 h-5" />
          </button>

          <button onClick={handleDelete} className="bg-red-500 p-1 rounded-md text-white">
            <DeleteIcon className="w-5 h-5" />
          </button>
        </div>
      </td>
    </tr>
  );
};

export default EstudianteActivoCard;


